import { createAction } from '@reduxjs/toolkit';

export const setErrors = createAction('user/setAuthErrors');

export const signout = createAction('user/signout');
